import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getPickups = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/pickups?${params.toString()}`);
};

const getClOrderRequests = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/cl-orders?${params.toString()}`);
};

const updateClOrderRequestStatus = (clinicId, orderId, status) => {
    return axios.patch(`${API_URL}clinics/${clinicId}/cl-orders/${orderId}`, { status });
};

const labService = {
    getPickups,
    getClOrderRequests,
    updateClOrderRequestStatus,
};

export default labService;
